import { render, staticRenderFns } from "./StrategicAdviserProxyComponent.vue?vue&type=template&id=d563a192&scoped=true"
import script from "./StrategicAdviserProxyComponent.vue?vue&type=script&lang=js"
export * from "./StrategicAdviserProxyComponent.vue?vue&type=script&lang=js"
import style0 from "./StrategicAdviserProxyComponent.vue?vue&type=style&index=0&id=d563a192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d563a192",
  null
  
)

export default component.exports